import Vue from 'vue';
import {remove, find, isFunction} from 'lodash';

let getCode = function(js) {
    // Remove export default
    let ed = js.indexOf('export default');
    let curly = js.indexOf('{');
    if (ed != -1 && ed < curly) {
        js = js.substring(ed + 14);
    }

    let f;
    try {
        f = new Function(`return ${js}`);
    }
    catch {
        f = new Function(`return {}`);
    }
    return f();
};

// block: optional components

const compiler = require('vue-template-compiler');

// Function to interpret AST nodes
function interpretNode(node) {
    switch (node.type) {
    case 'Literal':
        return node.value;
    case 'Identifier':
        return node.name; // Return the name of the identifier, e.g., String, Number
    case 'ObjectExpression':
        return node.properties.reduce((obj, prop) => {
            obj[prop.key.name] = interpretNode(prop.value);
            return obj;
        }, {});
    case 'ArrayExpression':
        return node.elements.map(element => interpretNode(element));
    default:
        return null;
    }
}

// Function to convert the AST of defineProps to a usable object
function extractPropsFromAST(ast) {
    if (ast?.type === 'ObjectExpression') {
        return interpretNode(ast);
    }
    return null;
}

function getCompositionApiProps(componentCode) {
    try {
        const acorn = window.acorn;

        // Parse the JavaScript code to AST
        const ast = acorn.parse(componentCode, {sourceType: "module", ecmaVersion: 2020});

        // Function to traverse the AST and find defineProps call
        const findDefineProps = function(ast) {
            let propsDefinition = null;
            acorn.walk.simple(ast, {
                CallExpression(node) {
                    if (node.callee.name === 'defineProps') {
                        // Assumes the argument is an object literal
                        propsDefinition = node.arguments[0];
                    }
                }
            });
            return propsDefinition;
        }

        const propsDefinition = findDefineProps(ast);
        const props = extractPropsFromAST(propsDefinition);
        return props;
    } catch (error) {
        console.error("Error parsing component code:", error);
        return null;
    }
}

// Function to map string types to actual JavaScript constructors
function mapType(typeString) {
    const types = {
        "String": String,
        "Number": Number,
        "Boolean": Boolean,
        "Object": Object,
        "Array": Array,
        "Function": Function,
        "Symbol": Symbol
    };

    return types[typeString] || null;
}

function convertTypeToJsType(props) {
    Object.keys(props).forEach(key => {
        const prop = props[key];
        prop.type = mapType(prop.type);
    });
    return props;
}

const registerAdditionalComponents = (additionalComponents, components, homepage_type) => {
    if(!additionalComponents) return;
    additionalComponents.forEach(c => {
        try {
            let component = {};
            if (homepage_type == 'mb' && c.type == 'vue2') {
                component = getCode(c.code);
                let compiled = compiler.compileToFunctions(c.template);
                if (compiled && compiled.render) {
                    component.render = compiled.render;
                    component.staticRenderFns = compiled.staticRenderFns;
                    component.zoezi = {title: c.name, icon: 'mdi-sheep', ...component.zoezi};
                    component.name = `zoezi-addon-${c.id}`;
                    component.css = c.css;
                }
            } else {
                // In SF we create a render function which simply prints the name of the component
                component = {}
                if (c.builtIn) {
                    component.id = c.id;
                    component.name = c.id;
                    component.zoezi = {title: c.title, icon: c.icon, ui: c.ui};
                    component.props = convertTypeToJsType(c.props);
                } else {
                    const props = getCompositionApiProps(c.code);
                    if (props) {
                        component.props = props;
                    } else {
                        component = getCode(c.code);
                    }
                    component.zoezi = {title: c.name, icon: 'mdi-sheep', ...component.zoezi};
                    component.name = `zoezi-addon-${c.id}`;
                }

                component.render = function(h) {
                    return h('div', {class: 'fill-height zoezi-html-default'}, window.$translate(component.zoezi.title));
                }
            }
            component.zoezi.type = homepage_type;

            if (!components.find(x => x.name == component.name)) {
                components.push(component)
            }
        }
        catch {
            // Empty
        }
    });
};

import GroupTraining from './views/GroupTraining.vue';
import Html from './views/Html.vue';
import Text from './views/Text.vue';
import MenuItem from './components/MenuItem.vue';
import Carousel from './views/Carousel.vue';
import Video from './views/Video.vue';
import Button from './views/Button.vue';
import TabBar from './views/TabBar.vue';
import ExpansionPanel from './views/ExpansionPanel.vue';
import VueComponent from './views/VueComponent.vue';
import Card from './views/Card.vue';
import ResourceBooking from './views/ResourceBooking.vue';
import ResourceBookingCategory from './views/ResourceBookingCategory.vue';
import ResourceBookingStartPage from './views/ResourceBookingStartPage.vue';
import CountUp from './views/CountUp.vue';
import ReceiptList from './views/ReceiptList.vue';
import Shop from './views/Shop.vue';
import ResourceBookingServiceList from './views/ResourceBookingServiceList.vue';
import CourseList from './views/CourseList.vue';
import CourseCategoryList from './views/CourseCategoryList.vue';
import CourseStartPage from './views/CourseStartPage.vue';
import CourseBooking from './views/CourseBooking.vue';
import CourseBookingButton from './views/CourseBookingButton.vue';
import Report from './views/Report.vue';
import MyGreeting from './views/MyGreeting.vue';
import MyTrainingCards from './views/MyTrainingCards.vue';
import MyDoors from './views/MyDoors.vue';
import MyAccount from './views/MyAccount.vue';
import MyPage from './views/MyPage.vue';
import NewsDisplay from './views/NewsDisplay.vue';
import NewsList from './views/NewsList.vue';
import Checkout from './views/Checkout.vue';
import CheckoutButton from './views/CheckoutButton.vue';
import Separator from './views/Separator.vue';
import MyPaymentMethods from './views/MyPaymentMethods.vue';
import Empty from './views/Empty.vue';
import Image from './views/Image.vue';
import ImageText from './views/ImageText.vue';
import TextNext from './views/TextNext.vue';
import ProductCard from './views/ProductCard.vue';
import BottomDialog from './components/BottomDialog.vue';
import Stepper from './views/Stepper.vue';
import StepperContent from './views/StepperContent.vue';
import ContactForm from './views/ContactForm.vue';
import Logout from './views/Logout.vue';
import RequestAccountRemoval from './views/RequestAccountRemoval.vue';
import DatePicker from './components/DatePicker.vue';
import BottomBarButton from './views/BottomBarButton.vue';
import QrScanner from './views/QrScanner.vue';
import SiteSelector from './views/SiteSelector.vue';
import SiteSelectorAndAccountButton from './views/SiteSelectorAndAccountButton.vue';
import MyBusinessFooter from './views/MyBusinessFooter.vue';
import SocialIcons from './views/SocialIcons.vue';
import Anchor from './views/Anchor.vue';
import OpenHours from './views/OpenHours.vue';
import StaffList from './views/StaffList.vue';
import CuratorIO from './views/CuratorIO.vue';
import WorkoutTypes from './views/WorkoutTypes.vue';
import ActivityCalendar from './views/ActivityCalendar.vue';
import ComingPayments from './views/ComingPayments.vue';
import GetCalendarButton from './views/GetCalendarButton.vue';
import GoogleMap from './views/GoogleMap.vue';
import CollectionReceipt from './views/CollectionReceipt.vue';
import MyEntryStats from './views/MyEntryStats.vue';
import MyWorkoutStats from './views/MyWorkoutStats.vue';
import CheckinButton from './components/CheckinButton.vue';
import LanguageMenu from './views/LanguageMenu.vue';
import MyTeamsportRegistrations from './views/MyTeamsportRegistrations.vue';
import TeamsportNextMatch from './views/Teamsport/NextMatch.vue';
import TeamsportPreviousMatch from './views/TeamsportPreviousMatch.vue';
import TeamsportComingMatches from './views/TeamsportComingMatches.vue';
import TeamsportTeamManagement from './views/TeamsportTeamManagement.vue';
import TeamsportMatch from './views/Teamsport/Match.vue';
import TeamsportCategoryList from './views/TeamsportCategoryList.vue';
import TeamsportGameclassOverview from './views/TeamsportGameclassOverview.vue';
import TeamsportDivision from './views/TeamsportDivision.vue';
import TeamsportTable from './views/TeamsportTable.vue';
import TeamsportToplist from './views/TeamsportToplist.vue';
import TeamsportPlayoffTree from './views/TeamsportPlayoffTree.vue';
import TeamsportPlayerPool from './views/TeamsportPlayerPool.vue';
import Visitors from './views/Visitors.vue';
import TeamsportCompetitionList from './views/TeamsportCompetitionList.vue';
import CurrentAndNextBooking from './components/Resource/CurrentAndNextBooking.vue';
import ResourceAvailabilityWrapper from './components/Resource/ResourceAvailabilityWrapper.vue';
import ClockDate from './components/ClockDate.vue';
import SignContract from './views/SignContract.vue';
import StaffInfoDialog from './components/StaffInfoDialog.vue';
import ResourceBookingFlow from './components/ResourceBookingFlow/ResourceBookingFlow.vue';
import TermsForChain from './views/TermsForChain.vue';
import PdfTable from './views/PdfTable.vue';

// StaffFlex components
import SfRowLayout from './sf/SfRowLayout.vue';
import SfRow from './sf/SfRow.vue';
import SfColumn from './sf/SfColumn.vue';
import SfEmpty from './sf/SfEmpty.vue';


let optionalComponents = [
    GroupTraining, Html, Text, Carousel, MenuItem, Image, ImageText, Video,
    Button, TabBar, ExpansionPanel, VueComponent, Card, ResourceBooking, ResourceBookingCategory, CountUp,
    ReceiptList, Shop, Empty,
    ResourceBookingFlow,
    ResourceBookingServiceList, CourseList, CourseCategoryList, CourseStartPage, Report, MyGreeting, MyTrainingCards,
    MyDoors, MyAccount, MyPage, NewsList, NewsDisplay, TextNext, Checkout, CheckoutButton, MyPaymentMethods,
    CourseBooking, CourseBookingButton, ProductCard, Stepper, StepperContent, BottomDialog, ContactForm, Separator,
    Logout, RequestAccountRemoval, DatePicker, ResourceBookingStartPage,BottomBarButton, QrScanner, SiteSelector, MyBusinessFooter, SocialIcons, Anchor,
    OpenHours, StaffList, CuratorIO, WorkoutTypes, ActivityCalendar, ComingPayments, GetCalendarButton, GoogleMap, CollectionReceipt,
    MyEntryStats, MyWorkoutStats, SiteSelectorAndAccountButton, TeamsportCategoryList, CheckinButton, TeamsportCompetitionList, MyTeamsportRegistrations, TeamsportNextMatch,  TeamsportPreviousMatch, TeamsportComingMatches, TeamsportTeamManagement, TeamsportMatch,
    TeamsportDivision, TeamsportTable, TeamsportToplist, TeamsportPlayerPool, Visitors, LanguageMenu, TeamsportGameclassOverview, TeamsportPlayoffTree, ClockDate, CurrentAndNextBooking, ResourceAvailabilityWrapper,
    SignContract, StaffInfoDialog, TermsForChain, PdfTable
];

const sfComponents = [SfRowLayout, SfRow, SfColumn, SfEmpty];

optionalComponents = optionalComponents.concat(sfComponents);

// ~block: optional components


/* Components which can be attached dynamically but not present in config */
import ComponentWrapper from './components/ComponentWrapper.vue';
import ContentsContainer from './components/ContentsContainer.vue'
import AutoImg from './components/AutoImg.vue';
import VueDraggable from 'vuedraggable';
import ErrorDialog from './components/ErrorDialog.vue';
import FormField from './components/FormField.vue';
import MediaLibrary from './components/MediaLibrary.vue';
import TemplateSettings from './views/TemplateSettings.vue';
import Page from './components/Page.vue';
import RowLayout from './views/RowLayout.vue';
import Row from './views/Row.vue';
import Column from './views/Column.vue';
import Login from './views/Login.vue';
import Terms from './views/Terms.vue';
import ResetPassword from './views/ResetPassword.vue';
import Unsubscribe from './views/Unsubscribe.vue';
import MailingUnsubscribe from './views/MailingUnsubscribe.vue';
import CookieBar from './views/CookieBar.vue';
import AccountButton from './views/AccountButton.vue';
import AppBar from './views/AppBar.vue';
import ResponsiveAppBar from './views/ResponsiveAppBar.vue';
import BottomBar from './components/AppBottomBar.vue';
import Root from './components/Root.vue';
import SfRoot from './sf/SfRoot.vue';
import SfPage from './sf/SfPage.vue';
import ExpoSettings from './views/ExpoSettings.vue';
import TeamsportBooking from './views/TeamsportBooking.vue';
import TeamsportEventTypePreview from './views/TeamsportEventTypePreview.vue';
import PopupContainer from './components/PopupContainer.vue';
import CustomFormFields from './components/CustomFormField.vue';
import CustomForm from './components/CustomForm.vue';
import ZoeziLink from './components/ZoeziLink.vue';

let components = [...optionalComponents, Page, RowLayout, Row, Column, Login, Terms, ResetPassword, Unsubscribe, MailingUnsubscribe, CookieBar, AccountButton, AppBar, ResponsiveAppBar, BottomBar, Root, TeamsportBooking, TeamsportEventTypePreview, SfRoot, SfPage, PopupContainer, CustomFormFields, CustomForm];

// Components available for external partners through the development
// portal. Not accessible from the Flex tool.
Vue.component('ContentsContainer', ContentsContainer);
Vue.component('component-wrapper', ComponentWrapper)
Vue.component('v-auto-img', AutoImg)
import { VBtn } from 'vuetify/lib';
Vue.component('v-btn', VBtn)
Vue.component('v-draggable', VueDraggable)
Vue.component('ErrorDialog', ErrorDialog)
Vue.component('FormField', FormField)
Vue.component('MediaLibrary', MediaLibrary)
Vue.component('zoezi-template-settings', TemplateSettings) // FIXME: Temporary
components.push(TemplateSettings);
Vue.component('zoezi-exposettings', ExpoSettings)
components.push(ExpoSettings)
Vue.component('zoezi-link', ZoeziLink)

import editmode_components from './editmode_components.js';
editmode_components(components);


let getType = function(prop) {
    let type = 'text';
    if (prop.fulltype !== undefined) {
        type = prop.fulltype;
    } else {
        if (prop.type === String) {
            type = 'text';
        } else if (prop.type === Boolean) {
            type = 'checkbox';
        } else if (prop.type == Number) {
            type = 'number';
        }
    }

    return type;
}

export default {
    registerVueComponents(additionalComponents, siteconfig, homepage_type) {
        registerAdditionalComponents(additionalComponents, components, homepage_type);
        this.updateOwnComponents(siteconfig);
        let typeIsCompatible = c => (c?.zoezi?.type || 'mb') == homepage_type;
        components = components.filter(typeIsCompatible)
        components.forEach(c => {
            Vue.component(c.name, c);
        })

        this.setComponentDefaults(siteconfig);
    },
    updateOwnComponents(siteconfig) {
        if (siteconfig.ownComponents) {
            Object.values(siteconfig.ownComponents).forEach(c => {
                try {
                    let component = Object.assign({}, getCode(c.js));
                    component.zoezi = {
                        title: c.name,
                        icon: c.icon,
                        own: true
                    };
                    component.name = c.id;
                    let compilation = Vue.compile(c.html);
                    component.render = compilation.render;
                    component.staticRenderFns = compilation.staticRenderFns;
                    component.css = c.css;

                    let existing = this.getComponent(component.name);
                    if (!existing) {
                        components.push(component)
                    } else {
                        Object.assign(existing, component)
                    }
                    Vue.component(c.id, component)
                }
                catch {
                    // Empty
                }
            })
            this.setComponentDefaults(siteconfig);

            let own = components.filter(c => c.zoezi && c.zoezi.own);
            let toremove = own.filter(c => !siteconfig.ownComponents[c.name]);
            toremove.forEach(t => {
                let i = components.indexOf(t);
                components.splice(i, 1);
            })
        }
    },
    getComponent(componentName) {
        return components.find(x => x.name == componentName);
    },
    getComponentProps(componentName) {
        let result = [];
        let c = this.getComponent(componentName);
        if (!c) {
            return [];
        }
        for (const [prop_name, prop] of Object.entries(c.props || {})) {
            if (!prop.type || prop.type == Function || (prop.type == Array && !prop.fulltype) || (prop.type == Object && !prop.fulltype) || !prop.title) {
                continue;
            }

            let p = {name: prop_name, title: prop.title, type: getType(prop), default: prop.default, typeinfo: prop.typeinfo, global: prop.global, section: prop.section};
            result.push(p);
        }

        return result;
    },
    getAllComponents() {
        return components;
    },
    getComponents() {
        return components.filter(c => c.zoezi && !c.zoezi.internal);
    },
    getAllGlobalSettings() {
        return this.getAllComponents().map(component => {
            let props = this.getComponentProps(component.name).filter(prop => prop.global);
            return {component, props}
        }).filter(x => x.props.length);
    },
    addComponents(arr) {
        remove(arr, p => !!p.component);
        find(arr, x => x.id == 'component').options = components.map(pt => ({id: pt.name, name: pt.title})).sort((a, b) => a.name.localeCompare(b.name));

        components.forEach(component => {
            for (const [prop_name, prop] of Object.entries(component.props || {})) {
                if (prop.type == Function || prop.type == Array) {
                    continue;
                }

                let type = getType(prop);

                let visible = function(field, fields) {
                    let c = fields.find(f => f.id == 'component')
                    return field.component == c.value;
                };

                let getKey = function(field) {
                    if (field.component) {
                        return field.component + '.' + field.id;
                    }
                    return field.id;
                };

                let f = {id: 'props.' + prop_name, label: prop.title, type: type, visible: visible, component: component.name, initial: prop.default, getKey: getKey};
                arr.push(f);
            }
        });
    },
    addNewComponent(config) {
        this.makeEmptyConfig(config);
        // For a newly added component - try to find it using its id
        this.selectComponent(config.id);
    },
    makeEmptyConfig(config) {
        config = {id: '0'.repeat(8).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);}), component: 'zoezi-empty', props: {}, ...config};
        this.getComponentProps(config.component).forEach(prop => {
            if (prop.default !== undefined && config.props[prop.name] === undefined && !prop.global) {
                config.props[prop.name] = isFunction(prop.default) ? prop.default() : prop.default;
            }
        });

        let c = this.getComponent(config.component);
        if (c?.zoezi?.getDefaultStyle) {
            config.style = Object.assign({}, c.zoezi.getDefaultStyle());
        }

        return config;
    },
    selectComponent(id) {
        Vue.nextTick(() => {
            let elm = document.getElementById(id);

            let doSelect = function(x) {
                if (!x) {
                    return;
                }

                if (x.__vue__ && x.__vue__.select) {
                    x.__vue__.select();
                } else {
                    doSelect(x.parentElement);
                }
            }

            doSelect(elm);
        })
    },
    setComponentDefaults(siteconfig) {
        let getGlobalSetting = function(componentName, propName) {
            return siteconfig.componentDefaults?.[componentName]?.[propName];
        };

        this.getAllGlobalSettings().forEach(c => {
            c.props.forEach(prop => {
                if (c.component.props[prop.name] !== undefined) {
                    let value = getGlobalSetting(c.component.name, prop.name);
                    if (value !== undefined) {
                        c.component.props[prop.name].default = value;
                    }
                }
            })
        })
    },
    getLiveComponents(componentName) {
        let firstWrapper;
        let getAll = (node, items) => {
            if (!node) {
                return;
            }
            if (!firstWrapper && node.$options.name == 'ComponentWrapper') {
                this.firstWrapper = node;
            }

            node.$children.forEach((x) => getAll(x, items))

            if (node.$options.name == componentName) {
                items.push(node);
            }
        };

        let items = [];
        getAll(window.$vue, items);
        return items;
    },
    updateAllLiveComponents(componentName) {
        let components = this.getLiveComponents(componentName);
        components.forEach(c => {
            while (c && c.$options.name != 'ComponentWrapper') {
                c = c.$parent;
            }

            if (c && c.update) {
                c.update();
            }
        });
    },
    getCompiler() {
        return compiler;
    }
}
